import notFound from 'images/notfound.png';
import styles from './index.module.sass';
import title from 'images/title.png';
import logo from 'images/logo.png';
import CoinGround from 'components/coin-ground';
import Wrapper from 'components/wrapper';
import Title from 'components/title';
import Header from 'components/header';
import Envolope from 'components/envolope';
import Contents from 'components/contents';
import Main from 'components/main';
import SubTitle from 'components/sub-title';
import Logo from 'components/logo';

const NotFound = () => {
  return (
    <div>
      <CoinGround />
      <Wrapper show={true}>
        <Header>
          <Title>
            <img src={title} alt="title" />
          </Title>
        </Header>
        <Main>
          <Envolope />
          <SubTitle>
            輸入序號
            <br />
            領取專屬你的麻吉優惠
          </SubTitle>
          <Contents>
            <div className={styles['not-found']}>
              <img src={notFound} alt="not-found" />
            </div>
            <div className={styles.text}>
              頁面不存在唷
              <br />
              請重新回到上一頁
            </div>
          </Contents>
          <Logo icon={logo} />
        </Main>
      </Wrapper>
    </div>
  );
};

export default NotFound;
